import {
  createMuiTheme,
  CssBaseline,
  Drawer,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core";
import React from "react";
import Header from "../../../components/Admin/Header";
import red from "@material-ui/core/colors/red";
import MyDrawer from "../../../components/Admin/Drawer";
import { AboutPageProvider } from "../../../components/AboutPage/AboutPageContext";
import AboutPage from "./AboutPage";
import { useStyles, drawerWidth, theme } from "../theme.js";

const AboutPageAdminPage = (props) => {
  const classes = useStyles();

  return (
    <AboutPageProvider>
      <ThemeProvider theme={theme}>
        <Drawer
          className={classes.drawer}
          variant="permanent"
          classes={{
            paper: classes.drawerPaper,
          }}
          anchor="left"
        >
          <MyDrawer></MyDrawer>
        </Drawer>
        <div className={classes.adminMain}>
          <Header></Header>
          <AboutPage></AboutPage>
        </div>
        <CssBaseline></CssBaseline>
      </ThemeProvider>
    </AboutPageProvider>
  );
};

export default AboutPageAdminPage;
